import {
  GameList,
  GameProvider,
  GameStatus,
  GamesGamesClient,
  PopularGameList,
  Game,
  GameIdentifier,
  FilterQueryFilterEnum,
  GameType
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig, { platformType } from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const gamesClient = new GamesGamesClient(apiConfig, undefined, axiosInstance);

interface GetAllGamesParams {
  platform?: string;
  page?: number;
  limit?: number;
  sort?: string;
  provider?: GameProvider;
  status?: GameStatus;
  category?: string;
  filter?: FilterQueryFilterEnum;
  gameType?: GameType;
}

const handleGetPopularGames = async ({
  limit,
  page,
}: Pick<GetAllGamesParams, "limit" | "page">): Promise<PopularGameList> => {
  return (await gamesClient.getAllPopularGames(limit, page)).data;
};

const handleGetGameDetails = async (gameId: string): Promise<Game> => {
  return (await gamesClient.getGameDetail(gameId)).data;
};

const handleGetGameDetailsBySlug = async (slug: string): Promise<Game> => {
  return (await gamesClient.getGameDetailBySlug(slug)).data;
};

const handleGetAllGames = async (
  params: GetAllGamesParams,
): Promise<GameList> => {
  const { platform = platformType, page, limit, sort, provider, status, category, filter, gameType } = params;

  return (
    await gamesClient.getGamesByPlatform(
      platform,
      page,
      limit,
      sort,
      provider,
      status,
      category,
      filter,
      gameType
    )
  ).data;
};

const handleGetMyTopGames = async (limit?: number, page?: number) => {
  return (await gamesClient.getMyTopGames(limit, page)).data;
};

const handleGetMyChallengeInvitationDefaultGame =
  async (): Promise<GameIdentifier> => {
    return (await gamesClient.getChallengeInvitationDefaultGame()).data;
  };

export {
  handleGetPopularGames,
  handleGetGameDetails,
  handleGetGameDetailsBySlug,
  handleGetAllGames,
  GetAllGamesParams,
  handleGetMyTopGames,
  handleGetMyChallengeInvitationDefaultGame,
};
